<script setup>
import { computed } from "vue";
import { hasPermissionTo } from "../../Composables/usePermissions.js";

// Props

const props = defineProps({
    value: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

// Data

const notificationOptions = [
    {
        category: "updates",
        title: "Notify me of changes to lessons",
        channels: ["email"],
    },
    {
        category: "reminders",
        title: "Remind me of upcoming lessons",
        channels: ["email"],
    },
    {
        category: "recaps",
        title: "Send me a recap after each lesson",
        channels: ["email"],
    },
    /*{
        category: "marketing",
        title: "Marketing Messages",
        channels: ["email"],
    },*/
    {
        category: "agendas",
        title: "Daily Teacher Agenda",
        channels: ["email"],
        permission: "Teach",
    },
    /*{
        category: "crm",
        title: "Studio CRM Messages",
        channels: ["email"],
        permission: "Use CRM",
    },*/
];

// Computed

const formatNotificationPreferences = computed(() => {
    return Object.fromEntries(
        Object.entries(props.value).map(([key, value]) => [
            key,
            Object.entries(value)
                .filter(([_, isEnabled]) => isEnabled)
                .map(([type]) => type),
        ])
    );
});
</script>

<template>
    <div class="notification-preferences">
        <div
            v-for="option in notificationOptions.filter((e) => {
                return !e.permission || can(e.permission);
            })"
            :key="option.title"
        >
            <v-card-subtitle class="font-weight-bold">{{
                option.title
            }}</v-card-subtitle>
            <v-card-text>
                <v-btn-toggle
                    :value="formatNotificationPreferences[option.category]"
                    multiple
                    rounded
                >
                    <v-btn
                        v-for="(notification, key) in option.channels"
                        :key="key"
                        :value="notification"
                        small
                        active-class="primary--text"
                        dense
                        @click="
                            value[option.category][notification] =
                                !value[option.category][notification]
                        "
                        >{{ notification }}</v-btn
                    >
                </v-btn-toggle>
            </v-card-text>
        </div>
    </div>
</template>
